import { Beacon } from "../models/Beacon";

export const GET_LATEST_OR_NEARBY_BEACONS = "GET_LATEST_OR_NEARBY_BEACONS";
export const GET_BUSINESS_BEACONS_IN_GROUP = "GET_BUSINESS_BEACONS_IN_GROUP";
export const GET_BEACONS_COUNT = "GET_BEACONS_COUNT";
export const GET_BUSINESS_BEACONS_IN_GROUP_BY_DATE =
  "GET_BUSINESS_BEACONS_IN_GROUP_BY_DATE";
export const SET_BEACON_SEARCH_TEXT = "SET_BEACON_SEARCH_TEXT";
export const SET_CATEGORY_FILTER_VALUE = "SET_CATEGORY_FILTER_VALUE";
export const GET_USER_DETAILS = "GET_USER_DETAILS";

export interface GetLatestBeacons {
  type: typeof GET_LATEST_OR_NEARBY_BEACONS;
  payload: Array<Beacon> | undefined;
}

export interface GetNearbyBeacons {
  type: typeof GET_LATEST_OR_NEARBY_BEACONS;
  payload: Array<Beacon> | undefined;
}

export interface GetBeaconsInGroup {
  type: typeof GET_BUSINESS_BEACONS_IN_GROUP;
  payload: Array<Beacon> | undefined;
}

export interface GetBeaconsCount {
  type: typeof GET_BEACONS_COUNT;
  payload: number;
}

export interface GetBeaconsInGroupByDate {
  type: typeof GET_BUSINESS_BEACONS_IN_GROUP_BY_DATE;
  payload: Array<Beacon>;
}

export interface SetBeaconSearchText {
  type: typeof SET_BEACON_SEARCH_TEXT;
  payload: string | null;
}

export interface SetCategoryFilterValue {
  type: typeof SET_CATEGORY_FILTER_VALUE;
  payload: string | null;
}

export interface GetUserDetails {
  type: typeof GET_USER_DETAILS;
  payload: any // lazy typing, fix.
}

export type BeaconActions =
  | GetNearbyBeacons
  | GetLatestBeacons
  | GetBeaconsInGroup
  | GetBeaconsCount
  | GetBeaconsInGroupByDate
  | SetBeaconSearchText
  | SetCategoryFilterValue
  | GetUserDetails;
